module.exports = __webpack_public_path__ + "static/img/Picture4.fa42674.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191014/Picture4.jpg
// module id = JtOH
// module chunks = 1